const sortPoints = s => s.from < s.to ? [s.from, s.to] : [s.to, s.from]

const getSegmentOverlap = (first, second) => {
  const a = sortPoints(first)
  const b = sortPoints(second)

  return Math.max(0, Math.min(a[1], b[1]) - Math.max(a[0], b[0])) / (a[1] - a[0])
}

module.exports = {
  getSegmentOverlap
}



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/chart/helpers/segment_tools.js